import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { LEGAL_DETAILS, privacyMailto } from '../config/legal';
import { useI18n } from '../i18n/I18nContext';
import { getLegalCopy } from '../i18n/legalCopy';
import '../style/Homepage.css';

const PrivacyPolicy = () => {
  const { language } = useI18n();
  const copy = getLegalCopy(language);
  const page = copy.privacy;

  return (
    <div>
      <Header />
      <main className="info-page privacy-page">
        <section className="info-hero">
          <p className="eyebrow">{page.eyebrow}</p><h1>{page.title}</h1><p>{copy.updated} {page.intro}</p>
        </section>
        <section className="feature-grid info-grid privacy-grid">
          {page.summary.map(([title, body]) => <article className="feature-card" key={title}><h3>{title}</h3><p>{body}</p></article>)}
        </section>
        <section className="privacy-policy-section">
          <div className="section-heading"><p className="eyebrow">{page.details}</p></div>
          <div className="feature-grid info-grid privacy-grid">
            {page.sections.map(([title, body]) => <article className="feature-card" key={title}><h3>{title}</h3><p>{body}</p></article>)}
          </div>
        </section>
        <section className="privacy-inline-notice">
          <div><p className="eyebrow">{page.accountEyebrow}</p><h2>{page.accountTitle}</h2></div>
          <Link to="/account-and-google-privacy" className="secondary-button">{page.accountLink}</Link>
        </section>
        <section className="terms-content" aria-label={page.requestLabel}>
          <article className="terms-section-card"><h2>{page.requestTitle}</h2><div><p>{page.requestBody}</p><p><Link to="/contact?topic=privacy">{copy.common.contact}</Link> · <a href={privacyMailto}>{LEGAL_DETAILS.privacyEmail}</a></p></div></article>
          <article className="terms-section-card"><h2>{page.controllerTitle}</h2><div><p>{page.controllerBody}</p><p><Link to="/legal-notice">{copy.common.legal}</Link></p></div></article>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
